var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import-icon",
    transform: "translate(-2336 -1600)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 24,
    height: 24,
    transform: "translate(2336 1600)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_import_3451585",
    transform: "translate(2336 1600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    className: "hoverState",
    "data-name": "Path 1626",
    d: "M18,21H6a3,3,0,0,1-3-3V6A3,3,0,0,1,6,3h5a1,1,0,0,1,0,2H6A1,1,0,0,0,5,6V18a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V13a1,1,0,0,1,2,0v5A3,3,0,0,1,18,21Z",
    fill: "#33444e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    className: "hoverState",
    "data-name": "Path 1627",
    d: "M20.66,3.34a1,1,0,0,0-1.42,0L13,9.64l-1.29-1.3A1.006,1.006,0,0,0,10,9.05v4a1.015,1.015,0,0,0,1,1h4a1.006,1.006,0,0,0,.71-1.71l-1.3-1.29,6.3-6.29a1,1,0,0,0-.05-1.42Z",
    transform: "translate(0)",
    fill: "#33444e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.8c2651aae4a890773b04b408b9b15899.svg";
export { ForwardRef as ReactComponent };